import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';

export function imageValidator(maxSizeInBytes: number, targetWidth: number, targetHeight: number): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const file = control.value;

    if (!file) {
      return of(null); // No file, no validation error
    }

    // Check file size synchronously
    if (file.size > maxSizeInBytes) {
      return of({ maxFileSize: { requiredSize: maxSizeInBytes, actualSize: file.size } });
    }

    // Check dimensions asynchronously
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          if (img.width !== targetWidth || img.height !== targetHeight) {
            resolve({ invalidDimensions: { requiredWidth: targetWidth, requiredHeight: targetHeight, actualWidth: img.width, actualHeight: img.height } });
          } else {
            resolve(null); // Valid dimensions
          }
        };
        img.onerror = () => {
          resolve({ invalidImage: true }); // Not a valid image file
        };
        img.src = e.target.result;
      };
      reader.onerror = () => {
        resolve({ fileReadError: true }); // Error reading the file
      };
      reader.readAsDataURL(file);
    });
  };
}
